import { CurrencyIcon } from '~/components/collections';
import { useWalletIcon } from '~/hooks';
import { Currency, VehicleEngineType } from '~/shared';
import { StyledContainer } from './PriceBlock.styled';

const PriceBlock = ({
	price,
	engineType,
}: {
	price: number;
	engineType: VehicleEngineType;
}) => {
	const rubleIcon = useWalletIcon(Currency.Ruble, true);

	return (
		<StyledContainer $engineType={engineType}>
			<p>{price.toLocaleString('ru-RU')}</p>
			<CurrencyIcon icon={rubleIcon} size="md" />
		</StyledContainer>
	);
};

export { PriceBlock };
